import styles from './NextSteps.module.css';
import { classList } from '../../helpers/classList';

export interface NextStepsProps {
  /** Defaults to the standard heading; override only if a brand needs to. */
  title?: string;
  intro: React.ReactNode;
  /** One entry per numbered step. */
  steps: React.ReactNode[];
  /** Override the standard document illustration inside the mint well. */
  image?: string;
  imageAlt?: string;
  className?: string;
}

/*
 * The standard illustration: a referral document with a leaf check, from the
 * brand reference (tmp/brand). Strokes ride currentColor so the art well can
 * recolour it per theme.
 */
const DocumentCheckArt = () => (
  <svg
    viewBox='0 0 100 100'
    fill='none'
    stroke='currentColor'
    strokeWidth={3}
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden
  >
    <rect x='26' y='14' width='48' height='64' rx='8' />
    <path d='M38 32h24' />
    <path d='M38 44h24' />
    <path d='M38 56h14' />
    <circle cx='68' cy='68' r='14' fill='var(--global-color-leaf)' />
    <path d='M62 68l4 4 8-8' />
  </svg>
);

export const NextSteps = ({
  title = 'What happens next',
  intro,
  steps,
  image,
  imageAlt = '',
  className,
}: NextStepsProps) => (
  <section className={classList(styles.band, className)}>
    <div className={styles.inner}>
      <div className={styles.art}>{image ? <img src={image} alt={imageAlt} /> : <DocumentCheckArt />}</div>
      <div className={styles.content}>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.intro}>{intro}</p>
        <ol className={styles.steps}>
          {steps.map((step, i) => (
            <li key={i} className={styles.step}>
              <span>{step}</span>
            </li>
          ))}
        </ol>
      </div>
    </div>
  </section>
);
